import {BaseClient} from "./BaseClient";


export class BucketClient {
    baseClient: BaseClient

    constructor(baseClient: BaseClient) {
        this.baseClient = baseClient
    }

    async retrieveBuckets(programme:string): Promise<string[]> {
        return this.baseClient.getOk<string[]>(`/api/bucketIds?programme=${programme}`);
    }

    async retrieveCmuIds() {
        return this.baseClient.getOk<string[]>(`/api/cmuIds`);
    }
}
